import { useState } from "react";
import Header from "./components/Header";
import TabNavigation from "./components/TabNavigation";
import HomeTab from "./components/HomeTab";
import MessagesTab from "./components/MessagesTab";
import ProfileTab from "./components/ProfileTab";
import CreateBandModal from "./components/modals/CreateBandModal";
import CreateRecruitmentModal from "./components/modals/CreateRecruitmentModal";
import BandDetailModal from "./components/modals/BandDetailModal";
import BandMembersModal from "./components/modals/BandMembersModal";
import RecruitmentDetailModal from "./components/modals/RecruitmentDetailModal";
import MemberProfileModal from "./components/modals/MemberProfileModal";
import UserProfileModal from "./components/modals/UserProfileModal";
import ChatWindow from "./components/ChatWindow";

type TabType = "home" | "messages" | "profile";

function App() {
  const [activeTab, setActiveTab] = useState<TabType>("home");
  const [showCreateBandModal, setShowCreateBandModal] = useState(false);
  const [showCreateRecruitmentModal, setShowCreateRecruitmentModal] =
    useState(false);
  const [showBandDetailModal, setShowBandDetailModal] = useState(false);
  const [showBandMembersModal, setShowBandMembersModal] = useState(false);
  const [showRecruitmentDetailModal, setShowRecruitmentDetailModal] =
    useState(false);
  const [showMemberProfileModal, setShowMemberProfileModal] = useState(false);
  const [showUserProfileModal, setShowUserProfileModal] = useState(false);
  const [showChatWindow, setShowChatWindow] = useState(false);
  const [selectedBandName, setSelectedBandName] = useState("");
  const [selectedRecruitmentTitle, setSelectedRecruitmentTitle] = useState("");
  const [selectedMemberName, setSelectedMemberName] = useState("");
  const [selectedMemberInstrument, setSelectedMemberInstrument] = useState("");
  const [selectedMemberExperience, setSelectedMemberExperience] = useState("");
  const [chatTitle, setChatTitle] = useState("");

  const openBandDetail = (bandName: string) => {
    setSelectedBandName(bandName);
    setShowBandDetailModal(true);
  };

  const openBandMembers = (bandName: string) => {
    setSelectedBandName(bandName);
    setShowBandMembersModal(true);
  };

  const openMemberProfile = (
    name: string,
    instrument: string,
    experience: string
  ) => {
    setSelectedMemberName(name);
    setSelectedMemberInstrument(instrument);
    setSelectedMemberExperience(experience);
    setShowMemberProfileModal(true);
  };

  const openRecruitmentDetail = (recruitmentTitle: string) => {
    setSelectedRecruitmentTitle(recruitmentTitle);
    setShowRecruitmentDetailModal(true);
  };

  const openChat = (bandName: string) => {
    setChatTitle(bandName);
    setShowChatWindow(true);
  };

  return (
    <div className="bg-gray-50 min-h-screen font-[Poppins,sans-serif]">
      <Header onShowUserProfile={() => setShowUserProfileModal(true)} />

      <main className="container mx-auto px-4 py-6">
        <TabNavigation activeTab={activeTab} onTabChange={setActiveTab} />

        {activeTab === "home" && (
          <HomeTab
            onShowCreateBand={() => setShowCreateBandModal(true)}
            onShowCreateRecruitment={() => setShowCreateRecruitmentModal(true)}
            onShowBandDetail={openBandDetail}
          />
        )}
        {activeTab === "messages" && <MessagesTab onOpenChat={openChat} />}
        {activeTab === "profile" && (
          <ProfileTab
            onShowBandDetail={openBandDetail}
            onShowBandMembers={openBandMembers}
            onShowRecruitmentDetail={openRecruitmentDetail}
          />
        )}
      </main>

      {/* Modals */}
      {showCreateBandModal && (
        <CreateBandModal onClose={() => setShowCreateBandModal(false)} />
      )}
      {showCreateRecruitmentModal && (
        <CreateRecruitmentModal
          onClose={() => setShowCreateRecruitmentModal(false)}
        />
      )}
      {showBandDetailModal && (
        <BandDetailModal
          bandName={selectedBandName}
          onClose={() => setShowBandDetailModal(false)}
        />
      )}
      {showBandMembersModal && (
        <BandMembersModal
          bandName={selectedBandName}
          onClose={() => setShowBandMembersModal(false)}
          onShowMemberProfile={openMemberProfile}
        />
      )}
      {showRecruitmentDetailModal && (
        <RecruitmentDetailModal
          recruitmentTitle={selectedRecruitmentTitle}
          onClose={() => setShowRecruitmentDetailModal(false)}
        />
      )}
      {showMemberProfileModal && (
        <MemberProfileModal
          memberName={selectedMemberName}
          memberInstrument={selectedMemberInstrument}
          memberExperience={selectedMemberExperience}
          onClose={() => setShowMemberProfileModal(false)}
        />
      )}
      {showUserProfileModal && (
        <UserProfileModal onClose={() => setShowUserProfileModal(false)} />
      )}
      {showChatWindow && (
        <ChatWindow
          chatTitle={chatTitle}
          onClose={() => setShowChatWindow(false)}
        />
      )}
    </div>
  );
}

export default App;
